module.exports = __webpack_public_path__ + "img/add-products.3fecf825.svg";